module.exports = __webpack_public_path__ + "static/media/banner_woman_chat_es.795c838e.png";